export const enum TripOverviewModalType {
  AccommodationUpsell = 'accommodationUpsell',
  AddFlights = 'addFlights',
  ContinueWithSuggestedDate = 'continueWithSuggestedDate',
  DestinationSelector = 'destinationSelector',
  EditTrip = 'editTrip',
  ExternalError = 'externalError',
  FerryDetails = 'ferryDetails',
  FerryFilters = 'ferryFilters',
  FerryMultipleVehicles = 'ferryMultipleVehicles',
  FlightDetails = 'flightDetails',
  FlightsFilters = 'flightFilters',
  HotelFilters = 'hotelFilters',
  None = 'none',
  PaxSelector = 'paxSelector',
  PortSelector = 'portSelector',
  PremadeTripDescription = 'premadeTripDescription',
  PriceGuarantee = 'priceGuarantee',
  ReloadPage = 'reloadPage',
  RemoveDestination = 'removeDestination',
  TripCalendar = 'tripCalendar',
  TripPriceSummary = 'tripPriceSummary',
  WhyWeSuggest = 'whyWeSuggest',
}
